import React, { Component } from 'react';
import { connect } from 'react-redux';
import { confirmUsers } from '../../actions';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class UsersConfirmation extends Component {

  componentDidMount() {
    const { token } = this.props.match.params
    this.props.dispatch(confirmUsers(token, cookies.get('locale')))
  }

  render() {
    return (
      <div className='node child'
        style={{
            transform: `translate3d(
            ${this.props.client.x[0]}px,
            ${this.props.client.y[0]}px,
            0px)`,
        }}>
        <div className='content'>
          <p>{this.props.server.errors}</p>
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

export default connect(mapStateToProps)(UsersConfirmation);



// WEBPACK FOOTER //
// ./src/components/SignupLogin/UsersConfirmation.js